import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

export interface CrmItem {
  name: string;
  type: string;
  tutorialUrl: string;
  loginUrl: string;
}

interface CrmTokenRequest {
  token: string;
  userId: string;
  type: string;
}


export const crmSlice = createApi({
  reducerPath: 'crm',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');

      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    }
  }),
  tagTypes: ['Crm'],
  endpoints: (builder) => ({
    getCrms: builder.query<CrmItem[], void>({
      query: () => '/crms',
      providesTags: ['Crm'],
      transformResponse: (response: { success: boolean; data: CrmItem[] }) => response.data
    }),

    sendCrmToken: builder.mutation<any, CrmTokenRequest>({
      query: (body) => ({
        url: '/info', 
        method: 'POST',
        body
      })
    })
  })
});

export const { useGetCrmsQuery, useSendCrmTokenMutation } = crmSlice;
